
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'marketplace-storefront-public-ui',
  currentProjectVersion: 'static-1.12061',
  depVersions: {
  "marketplace-storefront-public-ui": "static-1.12061",
  "apollo-dlb": "static-3.86",
  "client-types": "static-1.459",
  "dashboard-client-types": "static-1.339",
  "data-fetching-client": "static-1.9619",
  "foundations-components": "static-1.7816",
  "foundations-components-legacy": "static-1.841",
  "foundations-theming": "static-1.4360",
  "googlemaps-react-wrapper": "static-1.3",
  "graphql": "static-1.80",
  "head-dlb": "static-1.4938",
  "hs-test-utils": "static-1.7961",
  "hub-http-shared-msw-handlers": "static-1.9828",
  "hubspot-dlb": "static-2.1832",
  "hubspot-url-utils": "static-1.4049",
  "HubStyleTokens": "static-2.11405",
  "I18n": "static-7.1610",
  "jasmine-runner": "static-1.6415",
  "marketplace-storefront-base": "static-1.12122",
  "quartz": "static-1.6947",
  "react-dlb": "static-1.77",
  "react-rhumb": "static-1.16609",
  "reactive-variable-buffer-atom": "static-1.2805",
  "reporting-testing-lib": "static-1.9199",
  "settings-ui-lib": "static-1.12467",
  "SharedI18nStrings": "static-1.182",
  "signup-ui-core": "static-1.10391",
  "source-map": "static-1.4",
  "trellis-ecosystem": "static-1.7026",
  "ui-addon-i18n": "static-1.11096",
  "ui-addon-react-router-dom": "static-1.9491",
  "unified-auth": "static-1.417",
  "unified-auth-core-lib": "static-1.698",
  "usage-tracker": "static-1.7282",
  "usage-tracker-core": "static-1.7132",
  "customer-data-property-utils": "static-1.8029",
  "hub-http": "static-1.6166",
  "integrations-lib": "static-1.15931",
  "marketplace-ui-common": "static-1.19489",
  "property-management-iframe": "static-1.12966",
  "quartz-config": "static-1.725",
  "quartz-core": "static-1.6166",
  "quartz-routing": "static-1.377",
  "quick-fetch": "static-1.3871",
  "react": "static-7.184",
  "rpc-client-utils": "static-1.4592",
  "ts-schema": "static-1.4032",
  "ui-universal-auth": "static-1.8903",
  "UIComponents": "static-3.8352",
  "apollo-stack-hubspot": "static-3.84",
  "enviro": "static-4.428",
  "hs-promise-rejection-tracking": "static-1.5489",
  "PortalIdParser": "static-2.388",
  "raven": "static-3.5829",
  "raven-hubspot": "static-1.6136",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "immutable": "static-2.77",
  "metrics-js": "static-1.9542",
  "react-redux": "static-7.70",
  "redux": "static-4.16",
  "styled-components": "static-2.88",
  "bend-plugin-trellis-migration": "static-1.3357",
  "moment": "static-3.26",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3224",
  "quartz-webpack": "static-1.3171",
  "bend-plugin-quartz-routing": "static-1.25",
  "fast-json-stable-stringify": "static-1.4",
  "bend-plugin-foundations-components": "static-1.4085",
  "floating-ui": "static-1.54",
  "foundations-assets": "static-1.4798",
  "foundations-theming-specialty": "static-1.2076",
  "framer-motion": "static-1.70",
  "hs-story-utils": "static-1.9374",
  "react-aria": "static-1.64",
  "react-create-root-preference": "static-1.9",
  "react-select-plus": "static-1.103",
  "react-utils": "static-2.5298",
  "react-virtualized": "static-2.97",
  "StyleGuideUI": "static-3.486",
  "tanstack-table": "static-1.53",
  "trellis-assets": "static-1.1642",
  "ui-fonts": "static-1.667",
  "ui-images": "static-2.1138",
  "bend-plugin-foundations-theming": "static-1.2843",
  "foundations-theming-base": "static-1.3345",
  "stylex": "static-1.31",
  "HeadJS": "static-2.740",
  "hs-test-utils-bend-plugin": "static-1.3072",
  "msw": "static-1.39",
  "testing-library": "static-1.150",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.220",
  "moment-timezone": "static-5.81",
  "jasmine": "static-4.4270",
  "ai-components-ui-library": "static-1.8787",
  "ai-rendering-library": "static-1.9886",
  "chirp-fetch": "static-1.1831",
  "connections-embed-lib": "static-1.891",
  "copilot-toolkit": "static-1.10963",
  "feedback-loader": "static-1.29192",
  "laboratory-lib": "static-3.7104",
  "marketplace-embed": "static-1.21911",
  "marketplace-ui-details": "static-1.9385",
  "marketplace-ui-reviews": "static-1.19445",
  "marketplace-ui-tracking": "static-1.13660",
  "sanitize-text": "static-1.8088",
  "ui-addon-video-player": "static-1.8643",
  "usage-tracker-multi": "static-1.5696",
  "usage-tracker-session-replay": "static-1.4968",
  "wootric-nps": "static-1.6928",
  "quartz-head": "static-1.612",
  "web-vitals": "static-1.3",
  "apollo-link-hub-http": "static-2.4594",
  "immer": "static-1.33",
  "immerable": "static-1.4099",
  "highcharts": "static-8.102",
  "hs-lodash": "static-4.45",
  "reporting-client-types": "static-1.2459",
  "reporting-data": "static-1.67266",
  "cssUtils": "static-1.778",
  "flux-actions": "static-1.330",
  "HubStyle": "static-2.11713",
  "PatternValidationJS": "static-1.437",
  "react-colorpicker": "static-2.10156",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10317",
  "rxjs": "static-5.10",
  "underscore": "static-1.8",
  "usage-tracker-container": "static-1.7272",
  "icons": "static-2.643",
  "marketplace-ui-apps-core": "static-1.18022",
  "storybook-react": "static-1.31",
  "trellis-story-utils": "static-1.4461",
  "foundations-components-test-utils": "static-1.5299",
  "quartz-i18n": "static-1.622",
  "react-input-autosize": "static-2.17",
  "google-sheets-integration-lib": "static-1.66",
  "microsoft-drive-integration-lib": "static-1.172",
  "fsm": "static-1.3678",
  "customer-data-objects": "static-1.7606",
  "property-translator": "static-1.5348",
  "hs-locale-management": "static-1.38",
  "frontend-preferences-client": "static-1.7872",
  "hs-promise-utils": "static-1.5539",
  "hubspot-apollo-client": "static-1.4822",
  "integrations-error-boundary-lib": "static-1.13346",
  "integrations-tracking-lib": "static-1.5542",
  "native-integrations-shared-strings": "static-1.7729",
  "reselect": "static-2.16",
  "sanitize": "static-1.4418",
  "superstore": "static-1.4712",
  "ui-shepherd-react": "static-3.10094",
  "ai-settings-ui-library": "static-1.7791",
  "hub-http-janus": "static-1.826",
  "hubspotter-http": "static-1.4606",
  "immutable-less": "static-1.4595",
  "marketplace-ui-client-types": "static-1.16896",
  "nav-meta": "static-1.29460",
  "react-window": "static-1.13",
  "self-service-api": "static-1.10191",
  "ui-addon-upgrades": "static-9.17903",
  "inbound-db-properties-service-client": "static-1.3795",
  "property-management-common": "static-1.5254",
  "ui-addon-iframeable": "static-1.8998",
  "dispatcher": "static-1.135",
  "general-store": "static-6.20",
  "mobile-manifest-mixins": "static-1.514",
  "module-federation": "static-1.21",
  "quartz-auth": "static-1.622",
  "quartz-test": "static-1.622",
  "quartz-tracking": "static-1.326",
  "history": "static-4.47",
  "react-router-dom": "static-5.26",
  "csstype": "static-1.50",
  "bender-build-tools": "static-1.3123",
  "autolinker": "static-3.11",
  "chatspot-core": "static-1.21009",
  "ContentUtils": "static-1.68189",
  "customer-data-objects-ui-components": "static-1.12968",
  "sassPrefix": "static-1.154",
  "avatar-components": "static-1.2441",
  "customer-data-filters-ui": "static-1.39547",
  "customer-data-reference-ui-components": "static-1.13101",
  "embedded-academy-lib": "static-1.14129",
  "ExportDialog": "static-6.10338",
  "highlight.js": "static-1.77",
  "markdown-it": "static-1.6",
  "reporting-action-components": "static-1.41140",
  "reporting-snowflake": "static-1.55884",
  "reporting-ui-components": "static-2.64537",
  "reporting-visualizations": "static-1.59342",
  "ui-addon-teams": "static-1.21472",
  "magpie-lib": "static-1.5523",
  "navigation-components": "static-1.17823",
  "magpie-types": "static-1.4983",
  "simple-logging-lib": "static-1.2994",
  "ai-studio-lib": "static-1.11429",
  "app-governance-lib": "static-1.1359",
  "developer-experience-shared-components": "static-1.10453",
  "transmute": "static-2.85",
  "ui-addon-integrations-directory-panel": "static-2.7940",
  "ui-product-approvals": "static-1.27974",
  "ui-tool-access": "static-1.10094",
  "usage-based-billing-components-lib": "static-1.8583",
  "usage-tracker-anonymous": "static-1.5699",
  "usage-tracker-public": "static-1.7093",
  "amplitude-session-replay-browser": "static-1.58",
  "inbound-db-meta-service-client": "static-1.3545",
  "persist-promise": "static-1.3653",
  "reference-resolvers": "static-1.8115",
  "ui-extensibility-client-types": "static-1.3876",
  "hubspot-apollo-cache": "static-1.281",
  "universal-page-editor-lib": "static-1.2957",
  "final-form": "static-1.68",
  "redux-toolkit": "static-1.7",
  "simple-data-table": "static-1.2608",
  "merchandise-lib": "static-1.262",
  "atom": "static-1.5017",
  "purchase-motions-components": "static-1.5780",
  "salesImages": "static-1.524",
  "batch-promise": "static-1.1496",
  "crm-component-utils": "static-1.38924",
  "crm-properties-common-lib": "static-1.5821",
  "customer-data-properties": "static-1.51346",
  "framework-data-schema-resolvers": "static-1.6823",
  "property-value-citations": "static-1.1960",
  "reference-resolvers-lite": "static-1.8039",
  "navigation-messaging": "static-1.7150",
  "hubspotter-http-shared-msw-handlers": "static-1.9826",
  "cms-field-types": "static-1.4756",
  "content-icons-ui": "static-1.2211",
  "customer-data-ui-utilities": "static-1.9771",
  "conversations-skeleton-state": "static-1.7194",
  "crm-message-bus": "static-1.42829",
  "customer-data-filters-ui-msw-helpers": "static-1.21982",
  "FormUrlGenerator": "static-2.4665",
  "framework-builder-read-service-client": "static-1.3964",
  "framework-data-schema-quick-fetch": "static-1.6728",
  "multi-account-reference-resolvers": "static-1.924",
  "onboarding-tours": "static-1.16486",
  "react-immutable-proptypes": "static-2.8",
  "reporting-datasets-permissions-lib": "static-1.13500",
  "academy-common-lib": "static-1.13589",
  "content-assistance-lib": "static-1.7662",
  "dashboard-lib": "static-1.81293",
  "file-manager-components": "static-1.23452",
  "getting-started-shared-tasks": "static-1.18337",
  "hubspot-prosemirror": "static-1.18066",
  "hubspot-prosemirror-plugins": "static-1.18058",
  "prosemirror": "static-1.13",
  "rich-text-lib": "static-1.19728",
  "share-with-third-party-component-lib": "static-1.8642",
  "ui-addon-draggable": "static-3.4715",
  "ui-asset-management-lib": "static-1.10947",
  "ui-business-units-lib": "static-1.8991",
  "user-context": "static-1.5046",
  "growth-payments-core": "static-1.25197",
  "reporting-plugins": "static-1.10197",
  "reporting-reports": "static-1.66944",
  "idb-keyval": "static-1.42",
  "reactive-lib": "static-1.666",
  "nest": "static-1.169",
  "codemirror": "static-5.93",
  "react-codemirror": "static-1.10569",
  "framework-listing-lib": "static-2.28514",
  "fuzzy": "static-1.8",
  "user-configuration-lib": "static-1.30561",
  "apps-service-types": "static-1.3822",
  "oauth-service-types": "static-1.4194",
  "onboarding-scopes": "static-1.6408",
  "onboarding-tours-client": "static-1.4700",
  "platform-infra-nav-components": "static-1.7626",
  "subscription-experience-data-types": "static-1.14831",
  "crm-record-cards-service-types": "static-1.3565",
  "location-customization-utils-lib": "static-1.9071",
  "redux-thunk": "static-2.43",
  "purchase-motions-api": "static-1.5783",
  "signup-constants": "static-1.18737",
  "signup-ui-url-generator": "static-2.7982",
  "trials-service-types": "static-1.3848",
  "card-properties-lib": "static-1.43999",
  "commerce-subscription-lib": "static-1.36936",
  "crm-actions": "static-1.6262",
  "crm-cards-sdk": "static-1.43408",
  "customer-data-properties-shared-msw-handlers": "static-1.9155",
  "customer-data-tracking": "static-1.6831",
  "hs-resources": "static-1.87",
  "pulse": "static-1.498",
  "calling-global-api": "static-1.64305",
  "calling-internal-common": "static-1.31246",
  "calling-lifecycle-internal": "static-1.65687",
  "calling-lifecycle-messages": "static-1.57981",
  "commerce-products-lib": "static-1.9313",
  "conditional-properties-service-client": "static-1.3751",
  "crm-links": "static-1.6225",
  "external-options-client-types": "static-1.4113",
  "google-libphonenumber": "static-1.36",
  "inbounddb-objects-service-types": "static-1.4178",
  "meetings-icalendar-utils-lib": "static-1.576",
  "multi-currency-client-types": "static-1.3646",
  "object-builder-ui-client": "static-1.48543",
  "pipeline-validation-client-types": "static-1.3920",
  "smart-property-lib": "static-1.6656",
  "tiered-pricing": "static-1.1085",
  "ui-addon-form-validation": "static-1.10934",
  "crm-pipelines-api-client-types": "static-1.4097",
  "react-dnd-compat": "static-1.4565",
  "react-immutable-render-mixin": "static-1.9",
  "growth-data-modal": "static-1.5335",
  "growth-onboarding-confetti": "static-1.3013",
  "growth-onboarding-next-action-utils": "static-1.1745",
  "onboarding-tours-utils": "static-1.552",
  "ui-shepherd-tracker": "static-1.7475",
  "academy-service-client": "static-1.3627",
  "croppie": "static-2.10",
  "FileManagerCore": "static-1.38951",
  "FileManagerLib": "static-1.39092",
  "zustand": "static-1.72",
  "ui-coaching-tips": "static-1.28382",
  "redux-actions": "static-3.7",
  "ui-addon-opt": "static-4.8320",
  "video-components-external": "static-1.11082",
  "video-data-lib": "static-1.34740",
  "emoji-mart": "static-3.4",
  "knowledge-content-types": "static-1.8479",
  "payment-link-components": "static-1.23367",
  "ui-addon-emoji-picker": "static-1.9833",
  "EmailSignatureEditor": "static-1.24247",
  "viral-links-lib": "static-1.6997",
  "data-token-picker": "static-1.16300",
  "react-flip-move": "static-1.68",
  "nested-table": "static-1.171",
  "timezone-utils": "static-2.5189",
  "getting-started-shared-tasks-store": "static-1.17455",
  "campaign-roi-lib": "static-1.8902",
  "diff-match-patch": "static-1.7",
  "browser-eslint": "static-2.57",
  "customer-data-associations": "static-1.7271",
  "customer-data-views-management": "static-1.25337",
  "framework-data-table": "static-2.11784",
  "marketing-platform-lib": "static-1.6796",
  "nudge-client-utils": "static-1.2431",
  "nudge-custom-ui-functions": "static-1.911",
  "app-users-service-client": "static-1.5529",
  "app-users-service-types": "static-1.4937",
  "mini-checkout-client": "static-1.26656",
  "onboarding-utils": "static-1.5296",
  "permissions-shared-i18n-strings-fe": "static-1.2019",
  "ui-coaching-tips-shared-config": "static-1.28367",
  "edison-service-client-types": "static-1.331",
  "crm_data": "static-4.91769",
  "customer-data-sidebar": "static-2.45836",
  "enrichment-properties-lib": "static-1.15774",
  "commerce-billing-lib": "static-1.18896",
  "commerce-shared-components-lib": "static-1.18355",
  "commerce-tools-ui-lib": "static-1.10217",
  "crm-fe-perf": "static-1.22849",
  "bend-plugin-pulse": "static-1.1",
  "directed-graph": "static-1.881",
  "event-emitter": "static-1.894",
  "fast-json-patch": "static-1.61",
  "calling-error-reporting": "static-1.31252",
  "shared-worker-versioning": "static-1.10982",
  "calling-usage-tracker": "static-1.6487",
  "voice-sms-access-library": "static-1.750",
  "commerce-permissions": "static-1.710",
  "products-iframe-lib": "static-1.7759",
  "products-ui-components-shared-msw-handlers": "static-1.10210",
  "data-agent-kit": "static-1.102",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.9911",
  "policy-lib": "static-1.6717",
  "react-tinymce": "static-1.55076",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.9974",
  "tinymce": "static-5.11",
  "tinymce-config": "static-2.54202",
  "tinymce-plugins": "static-1.57316",
  "tinymce-themes": "static-1.56172",
  "onboarding-data-sync-lib": "static-1.1860",
  "growth-onboarding-next-action-components": "static-1.1773",
  "user-context-client": "static-1.4555",
  "audio-components": "static-1.5827",
  "cropperjs": "static-1.10",
  "FileManagerImages": "static-1.36603",
  "urlinator": "static-1.4477",
  "video-components": "static-1.13085",
  "video-embed": "static-1.35574",
  "growth-onboarding-feedback-components": "static-1.6529",
  "content-media-composition-data-lib": "static-1.12057",
  "content-media-compositions": "static-2.16064",
  "media-bridge-lib": "static-1.18824",
  "commerce-tours-lib": "static-1.5986",
  "growth-onboarding-reliability": "static-1.5027",
  "sales-checkout-service-client": "static-1.3584",
  "draft-convert": "static-2.71",
  "draft-extend": "static-3.73",
  "draft-js": "static-5.76",
  "draft-plugins": "static-2.21568",
  "sales-email-signature-service-client": "static-1.3787",
  "ts-utils-lib": "static-1.117",
  "crm-export-dialog": "static-1.6243",
  "crm-index-associations-lib": "static-1.6384",
  "react-beautiful-dnd": "static-1.13",
  "deal-intel-decorators": "static-1.1809",
  "tanstack-virtual": "static-1.28",
  "nudge-custom-function-registry": "static-1.2188",
  "nudge-renderer-utils": "static-1.2507",
  "whisper-core-api": "static-1.6440",
  "InboxConnectUtils": "static-4.14639",
  "emoji-regex": "static-1.7",
  "touchless-buying-components": "static-1.5373",
  "settings-content-modals": "static-1.45911",
  "crm_universal": "static-1.21903",
  "customer-data-email": "static-1.17930",
  "card-payment-highlight-lib": "static-1.37000",
  "card-subscription-highlight-lib": "static-1.39359",
  "commerce-contract-lib": "static-1.11810",
  "invoices-highlight-card-lib": "static-1.54519",
  "orders-highlight-card-lib": "static-1.21295",
  "products-highlight-card-lib": "static-1.17597",
  "quotes-highlight-card-lib": "static-1.71782",
  "crm-source-interpretation-lib": "static-1.5281",
  "utility-belt": "static-1.2483",
  "payments-enrollment-embed-lib": "static-1.22495",
  "stripe-embedded-components": "static-1.7398",
  "customer-data-rte": "static-1.32841",
  "cv-backend-services": "static-1.1551",
  "growth-onboarding-empty-states": "static-1.5609",
  "payments-post-enroll-local-storage-lib": "static-1.5055",
  "qrcode-generator": "static-1.67",
  "quotes-client-types": "static-1.37872",
  "calling-orchestration-schema": "static-1.35527",
  "sales-views-client-types": "static-1.4209",
  "hub-http-contrib": "static-1.2985",
  "interframe": "static-3.4706",
  "tinymce-data": "static-1.40287",
  "ui-addon-sales-email": "static-1.5155",
  "layout-dnd-components": "static-1.12330",
  "layout-dnd-utils": "static-1.11305",
  "ui-brand-identity-lib": "static-1.14978",
  "NamespacedHubStyle": "static-2.9017",
  "social-insights-client-types": "static-1.21921",
  "outpost": "static-1.4135",
  "js-cookie": "static-1.18",
  "deal-intel-utils": "static-1.1813",
  "checkout-sdk": "static-3.23499",
  "checkout-service-types": "static-1.3781",
  "company-details-components": "static-1.6141",
  "payment-method-components": "static-1.6857",
  "pricing-pages-ui-components": "static-1.13582",
  "quote-checkout-service-types": "static-1.3423",
  "upgrade-catalog-service-types": "static-1.3469",
  "access-control-lib": "static-1.10383",
  "EmailComponents": "static-1.54603",
  "EmailData": "static-1.53280",
  "redux-less": "static-2.9429",
  "sequences-lib": "static-1.7938",
  "ui-gdpr-components": "static-1.10291",
  "products-ui-components": "static-1.39832",
  "quotes-ui-lib": "static-1.80503",
  "accounting-integrations-ui-components": "static-1.6967",
  "invoices-ui-lib": "static-1.54535",
  "commerce-products-api": "static-1.2203",
  "invoices-iframe-lib": "static-1.56593",
  "quotes-modal-lib": "static-1.102460",
  "stripe-connect-js": "static-1.67",
  "draft-content-plugins": "static-1.28109",
  "ContentData": "static-1.68264",
  "layout-data-lib": "static-1.9630",
  "hub-http-rxjs": "static-1.792",
  "normalizr": "static-3.9",
  "ramda": "static-1.7",
  "company-details-service-types": "static-1.3877",
  "billing-payments-client-types": "static-1.3935",
  "react-performance-metrics-lib": "static-1.503",
  "account-and-billing-fintech-outages": "static-3.18485",
  "pricing-pages-api": "static-1.13447",
  "ContentComponents": "static-2.71145",
  "marketing-contacts-lib": "static-1.9747",
  "marketing-email-service-types": "static-1.1878",
  "messaging-editing-lib": "static-1.46091",
  "messaging-usage-based-billing-components-lib": "static-1.953",
  "automation-ui-source-apps": "static-1.18698",
  "automation-ui-types": "static-1.19616",
  "messaging-types-lib": "static-1.45828",
  "onboarding-settings-client": "static-1.4447",
  "sequences-client-types-lib": "static-1.7795",
  "commerce-tax-lib": "static-1.467",
  "property-description-translator": "static-1.3793",
  "SalesContentIndexUI": "static-3.9157",
  "commerce-analytics-service-client": "static-1.3572",
  "totals-ui-components": "static-1.23418",
  "advanced-menus-core": "static-1.15036",
  "advanced-menus-lib": "static-1.11990",
  "ui-memberships-settings-lib": "static-1.33887",
  "segments-query-core": "static-1.1359",
  "demographics-service-types": "static-1.1597",
  "eligibility-engine-service-types": "static-1.3129",
  "automation-ui-ubb": "static-1.5532",
  "blueimp-md5": "static-1.8",
  "content-embed-lib": "static-1.7285",
  "data-token-views": "static-1.16281",
  "forms-utils-lib": "static-1.12468",
  "payments-embed-points-lib": "static-1.12910",
  "simple-menus-core": "static-1.15035",
  "simple-menus-lib": "static-1.16552",
  "ui-addon-draggable-compat": "static-2.4200",
  "videoconference-integration-components": "static-1.6735",
  "automation-applications-service-types": "static-1.3457",
  "automation-platform-service-types": "static-1.2562",
  "ContentEditorUI": "static-2.76948",
  "short-messages-app-service-client": "static-1.3925",
  "web-interactives-components": "static-1.13658",
  "web-interactives-data": "static-1.13659",
  "messaging-shared-utils-lib": "static-1.402",
  "messaging-user-info-utils-lib": "static-1.572",
  "email-portal-health-service-types": "static-1.921",
  "FireAlarmUi": "static-1.4468",
  "sales-templates-service-types-lib": "static-1.4122",
  "commerce-totals-service-types": "static-1.3773",
  "seamless-immutable": "static-7.6",
  "automation-ui-core": "static-2.21552",
  "automation-ui-usage-tracking": "static-1.21015",
  "data-studio-ubb": "static-1.2544",
  "backbone": "static-1.6",
  "campaigns-lib": "static-1.26858",
  "collaboration-sidebar": "static-1.57621",
  "content-management-data-lib": "static-1.5310",
  "copilot-plugins": "static-1.10936",
  "cta-picker": "static-1.36245",
  "customer-agent-discovery-components-lib": "static-1.2914",
  "editor-components": "static-1.13150",
  "editor-iframe-lib": "static-1.8321",
  "error-messaging-js": "static-1.5137",
  "FormsCommonComponents": "static-1.85678",
  "pictos": "static-7.183",
  "react-transition-group": "static-2.63",
  "redux-request-state": "static-1.10592",
  "SharedLegalStrings": "static-1.1690",
  "smart-content-core": "static-1.42274",
  "smart-content-lib": "static-1.42927",
  "social-composer-lib": "static-1.58836",
  "structured-content-lib": "static-1.25033",
  "theme-previewer-lib": "static-1.53091",
  "tinymce-copilot": "static-1.16270",
  "xray-recommendation-lib": "static-1.7823",
  "automation-ui-routing": "static-1.20973",
  "sql-reporting-client-types": "static-1.5583",
  "jquery": "static-3.6",
  "attribution-lib": "static-1.42038",
  "campaigns-utils-lib": "static-1.3109",
  "reporting-enablement": "static-1.22699",
  "chatspot-widget-iframe": "static-1.21000",
  "collaboration-sidebar-common": "static-1.2418",
  "forms-ai-lib": "static-1.4225",
  "codemirror-dlb": "static-1.58507",
  "redux-mock-store": "static-1.8",
  "redux-undo": "static-1.10",
  "seo-tools-lib": "static-1.6374",
  "report-customization-components": "static-1.12975",
  "data-quality-ui-library": "static-1.12732",
  "html-to-image": "static-1.52",
  "reporting-filters": "static-1.163",
  "reporting-insights-lib": "static-1.1561"
},
  depPathPrefixes: {
  "marketplace-storefront-public-ui": "/marketplace-storefront-public-ui/static-1.12061",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "client-types": "/client-types/static-1.459",
  "dashboard-client-types": "/dashboard-client-types/static-1.339",
  "data-fetching-client": "/data-fetching-client/static-1.9619",
  "foundations-components": "/foundations-components/static-1.7816",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.841",
  "foundations-theming": "/foundations-theming/static-1.4360",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "graphql": "/graphql/static-1.80",
  "head-dlb": "/head-dlb/static-1.4938",
  "hs-test-utils": "/hs-test-utils/static-1.7961",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9828",
  "hubspot-dlb": "/hubspot-dlb/static-2.1832",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4049",
  "HubStyleTokens": "/HubStyleTokens/static-2.11405",
  "I18n": "/I18n/static-7.1610",
  "jasmine-runner": "/jasmine-runner/static-1.6415",
  "marketplace-storefront-base": "/marketplace-storefront-base/static-1.12122",
  "quartz": "/quartz/static-1.6947",
  "react-dlb": "/react-dlb/static-1.77",
  "react-rhumb": "/react-rhumb/static-1.16609",
  "reactive-variable-buffer-atom": "/reactive-variable-buffer-atom/static-1.2805",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.9199",
  "settings-ui-lib": "/settings-ui-lib/static-1.12467",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "signup-ui-core": "/signup-ui-core/static-1.10391",
  "source-map": "/source-map/static-1.4",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.7026",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11096",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9491",
  "unified-auth": "/unified-auth/static-1.417",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.698",
  "usage-tracker": "/usage-tracker/static-1.7282",
  "usage-tracker-core": "/usage-tracker-core/static-1.7132",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8029",
  "hub-http": "/hub-http/static-1.6166",
  "integrations-lib": "/integrations-lib/static-1.15931",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.19489",
  "property-management-iframe": "/property-management-iframe/static-1.12966",
  "quartz-config": "/quartz-config/static-1.725",
  "quartz-core": "/quartz-core/static-1.6166",
  "quartz-routing": "/quartz-routing/static-1.377",
  "quick-fetch": "/quick-fetch/static-1.3871",
  "react": "/react/static-7.184",
  "rpc-client-utils": "/rpc-client-utils/static-1.4592",
  "ts-schema": "/ts-schema/static-1.4032",
  "ui-universal-auth": "/ui-universal-auth/static-1.8903",
  "UIComponents": "/UIComponents/static-3.8352",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.84",
  "enviro": "/enviro/static-4.428",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5489",
  "PortalIdParser": "/PortalIdParser/static-2.388",
  "raven": "/raven/static-3.5829",
  "raven-hubspot": "/raven-hubspot/static-1.6136",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "immutable": "/immutable/static-2.77",
  "metrics-js": "/metrics-js/static-1.9542",
  "react-redux": "/react-redux/static-7.70",
  "redux": "/redux/static-4.16",
  "styled-components": "/styled-components/static-2.88",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3357",
  "moment": "/moment/static-3.26",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3224",
  "quartz-webpack": "/quartz-webpack/static-1.3171",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.25",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4085",
  "floating-ui": "/floating-ui/static-1.54",
  "foundations-assets": "/foundations-assets/static-1.4798",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2076",
  "framer-motion": "/framer-motion/static-1.70",
  "hs-story-utils": "/hs-story-utils/static-1.9374",
  "react-aria": "/react-aria/static-1.64",
  "react-create-root-preference": "/react-create-root-preference/static-1.9",
  "react-select-plus": "/react-select-plus/static-1.103",
  "react-utils": "/react-utils/static-2.5298",
  "react-virtualized": "/react-virtualized/static-2.97",
  "StyleGuideUI": "/StyleGuideUI/static-3.486",
  "tanstack-table": "/tanstack-table/static-1.53",
  "trellis-assets": "/trellis-assets/static-1.1642",
  "ui-fonts": "/ui-fonts/static-1.667",
  "ui-images": "/ui-images/static-2.1138",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2843",
  "foundations-theming-base": "/foundations-theming-base/static-1.3345",
  "stylex": "/stylex/static-1.31",
  "HeadJS": "/HeadJS/static-2.740",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3072",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.150",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.220",
  "moment-timezone": "/moment-timezone/static-5.81",
  "jasmine": "/jasmine/static-4.4270",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.8787",
  "ai-rendering-library": "/ai-rendering-library/static-1.9886",
  "chirp-fetch": "/chirp-fetch/static-1.1831",
  "connections-embed-lib": "/connections-embed-lib/static-1.891",
  "copilot-toolkit": "/copilot-toolkit/static-1.10963",
  "feedback-loader": "/feedback-loader/static-1.29192",
  "laboratory-lib": "/laboratory-lib/static-3.7104",
  "marketplace-embed": "/marketplace-embed/static-1.21911",
  "marketplace-ui-details": "/marketplace-ui-details/static-1.9385",
  "marketplace-ui-reviews": "/marketplace-ui-reviews/static-1.19445",
  "marketplace-ui-tracking": "/marketplace-ui-tracking/static-1.13660",
  "sanitize-text": "/sanitize-text/static-1.8088",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8643",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.5696",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.4968",
  "wootric-nps": "/wootric-nps/static-1.6928",
  "quartz-head": "/quartz-head/static-1.612",
  "web-vitals": "/web-vitals/static-1.3",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4594",
  "immer": "/immer/static-1.33",
  "immerable": "/immerable/static-1.4099",
  "highcharts": "/highcharts/static-8.102",
  "hs-lodash": "/hs-lodash/static-4.45",
  "reporting-client-types": "/reporting-client-types/static-1.2459",
  "reporting-data": "/reporting-data/static-1.67266",
  "cssUtils": "/cssUtils/static-1.778",
  "flux-actions": "/flux-actions/static-1.330",
  "HubStyle": "/HubStyle/static-2.11713",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "react-colorpicker": "/react-colorpicker/static-2.10156",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10317",
  "rxjs": "/rxjs/static-5.10",
  "underscore": "/underscore/static-1.8",
  "usage-tracker-container": "/usage-tracker-container/static-1.7272",
  "icons": "/icons/static-2.643",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.18022",
  "storybook-react": "/storybook-react/static-1.31",
  "trellis-story-utils": "/trellis-story-utils/static-1.4461",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5299",
  "quartz-i18n": "/quartz-i18n/static-1.622",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.66",
  "microsoft-drive-integration-lib": "/microsoft-drive-integration-lib/static-1.172",
  "fsm": "/fsm/static-1.3678",
  "customer-data-objects": "/customer-data-objects/static-1.7606",
  "property-translator": "/property-translator/static-1.5348",
  "hs-locale-management": "/hs-locale-management/static-1.38",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7872",
  "hs-promise-utils": "/hs-promise-utils/static-1.5539",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4822",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.13346",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5542",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7729",
  "reselect": "/reselect/static-2.16",
  "sanitize": "/sanitize/static-1.4418",
  "superstore": "/superstore/static-1.4712",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10094",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.7791",
  "hub-http-janus": "/hub-http-janus/static-1.826",
  "hubspotter-http": "/hubspotter-http/static-1.4606",
  "immutable-less": "/immutable-less/static-1.4595",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.16896",
  "nav-meta": "/nav-meta/static-1.29460",
  "react-window": "/react-window/static-1.13",
  "self-service-api": "/self-service-api/static-1.10191",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.17903",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3795",
  "property-management-common": "/property-management-common/static-1.5254",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.8998",
  "dispatcher": "/dispatcher/static-1.135",
  "general-store": "/general-store/static-6.20",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.514",
  "module-federation": "/module-federation/static-1.21",
  "quartz-auth": "/quartz-auth/static-1.622",
  "quartz-test": "/quartz-test/static-1.622",
  "quartz-tracking": "/quartz-tracking/static-1.326",
  "history": "/history/static-4.47",
  "react-router-dom": "/react-router-dom/static-5.26",
  "csstype": "/csstype/static-1.50",
  "bender-build-tools": "/bender-build-tools/static-1.3123",
  "autolinker": "/autolinker/static-3.11",
  "chatspot-core": "/chatspot-core/static-1.21009",
  "ContentUtils": "/ContentUtils/static-1.68189",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.12968",
  "sassPrefix": "/sassPrefix/static-1.154",
  "avatar-components": "/avatar-components/static-1.2441",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.39547",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13101",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.14129",
  "ExportDialog": "/ExportDialog/static-6.10338",
  "highlight.js": "/highlight.js/static-1.77",
  "markdown-it": "/markdown-it/static-1.6",
  "reporting-action-components": "/reporting-action-components/static-1.41140",
  "reporting-snowflake": "/reporting-snowflake/static-1.55884",
  "reporting-ui-components": "/reporting-ui-components/static-2.64537",
  "reporting-visualizations": "/reporting-visualizations/static-1.59342",
  "ui-addon-teams": "/ui-addon-teams/static-1.21472",
  "magpie-lib": "/magpie-lib/static-1.5523",
  "navigation-components": "/navigation-components/static-1.17823",
  "magpie-types": "/magpie-types/static-1.4983",
  "simple-logging-lib": "/simple-logging-lib/static-1.2994",
  "ai-studio-lib": "/ai-studio-lib/static-1.11429",
  "app-governance-lib": "/app-governance-lib/static-1.1359",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10453",
  "transmute": "/transmute/static-2.85",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.7940",
  "ui-product-approvals": "/ui-product-approvals/static-1.27974",
  "ui-tool-access": "/ui-tool-access/static-1.10094",
  "usage-based-billing-components-lib": "/usage-based-billing-components-lib/static-1.8583",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5699",
  "usage-tracker-public": "/usage-tracker-public/static-1.7093",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.58",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3545",
  "persist-promise": "/persist-promise/static-1.3653",
  "reference-resolvers": "/reference-resolvers/static-1.8115",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.3876",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.281",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.2957",
  "final-form": "/final-form/static-1.68",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "simple-data-table": "/simple-data-table/static-1.2608",
  "merchandise-lib": "/merchandise-lib/static-1.262",
  "atom": "/atom/static-1.5017",
  "purchase-motions-components": "/purchase-motions-components/static-1.5780",
  "salesImages": "/salesImages/static-1.524",
  "batch-promise": "/batch-promise/static-1.1496",
  "crm-component-utils": "/crm-component-utils/static-1.38924",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.5821",
  "customer-data-properties": "/customer-data-properties/static-1.51346",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6823",
  "property-value-citations": "/property-value-citations/static-1.1960",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8039",
  "navigation-messaging": "/navigation-messaging/static-1.7150",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9826",
  "cms-field-types": "/cms-field-types/static-1.4756",
  "content-icons-ui": "/content-icons-ui/static-1.2211",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9771",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7194",
  "crm-message-bus": "/crm-message-bus/static-1.42829",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.21982",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4665",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3964",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6728",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.924",
  "onboarding-tours": "/onboarding-tours/static-1.16486",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.13500",
  "academy-common-lib": "/academy-common-lib/static-1.13589",
  "content-assistance-lib": "/content-assistance-lib/static-1.7662",
  "dashboard-lib": "/dashboard-lib/static-1.81293",
  "file-manager-components": "/file-manager-components/static-1.23452",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.18337",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.18066",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.18058",
  "prosemirror": "/prosemirror/static-1.13",
  "rich-text-lib": "/rich-text-lib/static-1.19728",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8642",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4715",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.10947",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.8991",
  "user-context": "/user-context/static-1.5046",
  "growth-payments-core": "/growth-payments-core/static-1.25197",
  "reporting-plugins": "/reporting-plugins/static-1.10197",
  "reporting-reports": "/reporting-reports/static-1.66944",
  "idb-keyval": "/idb-keyval/static-1.42",
  "reactive-lib": "/reactive-lib/static-1.666",
  "nest": "/nest/static-1.169",
  "codemirror": "/codemirror/static-5.93",
  "react-codemirror": "/react-codemirror/static-1.10569",
  "framework-listing-lib": "/framework-listing-lib/static-2.28514",
  "fuzzy": "/fuzzy/static-1.8",
  "user-configuration-lib": "/user-configuration-lib/static-1.30561",
  "apps-service-types": "/apps-service-types/static-1.3822",
  "oauth-service-types": "/oauth-service-types/static-1.4194",
  "onboarding-scopes": "/onboarding-scopes/static-1.6408",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.4700",
  "platform-infra-nav-components": "/platform-infra-nav-components/static-1.7626",
  "subscription-experience-data-types": "/subscription-experience-data-types/static-1.14831",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3565",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.9071",
  "redux-thunk": "/redux-thunk/static-2.43",
  "purchase-motions-api": "/purchase-motions-api/static-1.5783",
  "signup-constants": "/signup-constants/static-1.18737",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.7982",
  "trials-service-types": "/trials-service-types/static-1.3848",
  "card-properties-lib": "/card-properties-lib/static-1.43999",
  "commerce-subscription-lib": "/commerce-subscription-lib/static-1.36936",
  "crm-actions": "/crm-actions/static-1.6262",
  "crm-cards-sdk": "/crm-cards-sdk/static-1.43408",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9155",
  "customer-data-tracking": "/customer-data-tracking/static-1.6831",
  "hs-resources": "/hs-resources/static-1.87",
  "pulse": "/pulse/static-1.498",
  "calling-global-api": "/calling-global-api/static-1.64305",
  "calling-internal-common": "/calling-internal-common/static-1.31246",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.65687",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.57981",
  "commerce-products-lib": "/commerce-products-lib/static-1.9313",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3751",
  "crm-links": "/crm-links/static-1.6225",
  "external-options-client-types": "/external-options-client-types/static-1.4113",
  "google-libphonenumber": "/google-libphonenumber/static-1.36",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4178",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.576",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3646",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.48543",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3920",
  "smart-property-lib": "/smart-property-lib/static-1.6656",
  "tiered-pricing": "/tiered-pricing/static-1.1085",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.10934",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4097",
  "react-dnd-compat": "/react-dnd-compat/static-1.4565",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "growth-data-modal": "/growth-data-modal/static-1.5335",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3013",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.1745",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.552",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7475",
  "academy-service-client": "/academy-service-client/static-1.3627",
  "croppie": "/croppie/static-2.10",
  "FileManagerCore": "/FileManagerCore/static-1.38951",
  "FileManagerLib": "/FileManagerLib/static-1.39092",
  "zustand": "/zustand/static-1.72",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.28382",
  "redux-actions": "/redux-actions/static-3.7",
  "ui-addon-opt": "/ui-addon-opt/static-4.8320",
  "video-components-external": "/video-components-external/static-1.11082",
  "video-data-lib": "/video-data-lib/static-1.34740",
  "emoji-mart": "/emoji-mart/static-3.4",
  "knowledge-content-types": "/knowledge-content-types/static-1.8479",
  "payment-link-components": "/payment-link-components/static-1.23367",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9833",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.24247",
  "viral-links-lib": "/viral-links-lib/static-1.6997",
  "data-token-picker": "/data-token-picker/static-1.16300",
  "react-flip-move": "/react-flip-move/static-1.68",
  "nested-table": "/nested-table/static-1.171",
  "timezone-utils": "/timezone-utils/static-2.5189",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.17455",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.8902",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "browser-eslint": "/browser-eslint/static-2.57",
  "customer-data-associations": "/customer-data-associations/static-1.7271",
  "customer-data-views-management": "/customer-data-views-management/static-1.25337",
  "framework-data-table": "/framework-data-table/static-2.11784",
  "marketing-platform-lib": "/marketing-platform-lib/static-1.6796",
  "nudge-client-utils": "/nudge-client-utils/static-1.2431",
  "nudge-custom-ui-functions": "/nudge-custom-ui-functions/static-1.911",
  "app-users-service-client": "/app-users-service-client/static-1.5529",
  "app-users-service-types": "/app-users-service-types/static-1.4937",
  "mini-checkout-client": "/mini-checkout-client/static-1.26656",
  "onboarding-utils": "/onboarding-utils/static-1.5296",
  "permissions-shared-i18n-strings-fe": "/permissions-shared-i18n-strings-fe/static-1.2019",
  "ui-coaching-tips-shared-config": "/ui-coaching-tips-shared-config/static-1.28367",
  "edison-service-client-types": "/edison-service-client-types/static-1.331",
  "crm_data": "/crm_data/static-4.91769",
  "customer-data-sidebar": "/customer-data-sidebar/static-2.45836",
  "enrichment-properties-lib": "/enrichment-properties-lib/static-1.15774",
  "commerce-billing-lib": "/commerce-billing-lib/static-1.18896",
  "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.18355",
  "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.10217",
  "crm-fe-perf": "/crm-fe-perf/static-1.22849",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.1",
  "directed-graph": "/directed-graph/static-1.881",
  "event-emitter": "/event-emitter/static-1.894",
  "fast-json-patch": "/fast-json-patch/static-1.61",
  "calling-error-reporting": "/calling-error-reporting/static-1.31252",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.10982",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6487",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.750",
  "commerce-permissions": "/commerce-permissions/static-1.710",
  "products-iframe-lib": "/products-iframe-lib/static-1.7759",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10210",
  "data-agent-kit": "/data-agent-kit/static-1.102",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.9911",
  "policy-lib": "/policy-lib/static-1.6717",
  "react-tinymce": "/react-tinymce/static-1.55076",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.9974",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-config": "/tinymce-config/static-2.54202",
  "tinymce-plugins": "/tinymce-plugins/static-1.57316",
  "tinymce-themes": "/tinymce-themes/static-1.56172",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.1860",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.1773",
  "user-context-client": "/user-context-client/static-1.4555",
  "audio-components": "/audio-components/static-1.5827",
  "cropperjs": "/cropperjs/static-1.10",
  "FileManagerImages": "/FileManagerImages/static-1.36603",
  "urlinator": "/urlinator/static-1.4477",
  "video-components": "/video-components/static-1.13085",
  "video-embed": "/video-embed/static-1.35574",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6529",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.12057",
  "content-media-compositions": "/content-media-compositions/static-2.16064",
  "media-bridge-lib": "/media-bridge-lib/static-1.18824",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.5986",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5027",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3584",
  "draft-convert": "/draft-convert/static-2.71",
  "draft-extend": "/draft-extend/static-3.73",
  "draft-js": "/draft-js/static-5.76",
  "draft-plugins": "/draft-plugins/static-2.21568",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.3787",
  "ts-utils-lib": "/ts-utils-lib/static-1.117",
  "crm-export-dialog": "/crm-export-dialog/static-1.6243",
  "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6384",
  "react-beautiful-dnd": "/react-beautiful-dnd/static-1.13",
  "deal-intel-decorators": "/deal-intel-decorators/static-1.1809",
  "tanstack-virtual": "/tanstack-virtual/static-1.28",
  "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.2188",
  "nudge-renderer-utils": "/nudge-renderer-utils/static-1.2507",
  "whisper-core-api": "/whisper-core-api/static-1.6440",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.14639",
  "emoji-regex": "/emoji-regex/static-1.7",
  "touchless-buying-components": "/touchless-buying-components/static-1.5373",
  "settings-content-modals": "/settings-content-modals/static-1.45911",
  "crm_universal": "/crm_universal/static-1.21903",
  "customer-data-email": "/customer-data-email/static-1.17930",
  "card-payment-highlight-lib": "/card-payment-highlight-lib/static-1.37000",
  "card-subscription-highlight-lib": "/card-subscription-highlight-lib/static-1.39359",
  "commerce-contract-lib": "/commerce-contract-lib/static-1.11810",
  "invoices-highlight-card-lib": "/invoices-highlight-card-lib/static-1.54519",
  "orders-highlight-card-lib": "/orders-highlight-card-lib/static-1.21295",
  "products-highlight-card-lib": "/products-highlight-card-lib/static-1.17597",
  "quotes-highlight-card-lib": "/quotes-highlight-card-lib/static-1.71782",
  "crm-source-interpretation-lib": "/crm-source-interpretation-lib/static-1.5281",
  "utility-belt": "/utility-belt/static-1.2483",
  "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.22495",
  "stripe-embedded-components": "/stripe-embedded-components/static-1.7398",
  "customer-data-rte": "/customer-data-rte/static-1.32841",
  "cv-backend-services": "/cv-backend-services/static-1.1551",
  "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.5609",
  "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.5055",
  "qrcode-generator": "/qrcode-generator/static-1.67",
  "quotes-client-types": "/quotes-client-types/static-1.37872",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.35527",
  "sales-views-client-types": "/sales-views-client-types/static-1.4209",
  "hub-http-contrib": "/hub-http-contrib/static-1.2985",
  "interframe": "/interframe/static-3.4706",
  "tinymce-data": "/tinymce-data/static-1.40287",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5155",
  "layout-dnd-components": "/layout-dnd-components/static-1.12330",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11305",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.14978",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9017",
  "social-insights-client-types": "/social-insights-client-types/static-1.21921",
  "outpost": "/outpost/static-1.4135",
  "js-cookie": "/js-cookie/static-1.18",
  "deal-intel-utils": "/deal-intel-utils/static-1.1813",
  "checkout-sdk": "/checkout-sdk/static-3.23499",
  "checkout-service-types": "/checkout-service-types/static-1.3781",
  "company-details-components": "/company-details-components/static-1.6141",
  "payment-method-components": "/payment-method-components/static-1.6857",
  "pricing-pages-ui-components": "/pricing-pages-ui-components/static-1.13582",
  "quote-checkout-service-types": "/quote-checkout-service-types/static-1.3423",
  "upgrade-catalog-service-types": "/upgrade-catalog-service-types/static-1.3469",
  "access-control-lib": "/access-control-lib/static-1.10383",
  "EmailComponents": "/EmailComponents/static-1.54603",
  "EmailData": "/EmailData/static-1.53280",
  "redux-less": "/redux-less/static-2.9429",
  "sequences-lib": "/sequences-lib/static-1.7938",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10291",
  "products-ui-components": "/products-ui-components/static-1.39832",
  "quotes-ui-lib": "/quotes-ui-lib/static-1.80503",
  "accounting-integrations-ui-components": "/accounting-integrations-ui-components/static-1.6967",
  "invoices-ui-lib": "/invoices-ui-lib/static-1.54535",
  "commerce-products-api": "/commerce-products-api/static-1.2203",
  "invoices-iframe-lib": "/invoices-iframe-lib/static-1.56593",
  "quotes-modal-lib": "/quotes-modal-lib/static-1.102460",
  "stripe-connect-js": "/stripe-connect-js/static-1.67",
  "draft-content-plugins": "/draft-content-plugins/static-1.28109",
  "ContentData": "/ContentData/static-1.68264",
  "layout-data-lib": "/layout-data-lib/static-1.9630",
  "hub-http-rxjs": "/hub-http-rxjs/static-1.792",
  "normalizr": "/normalizr/static-3.9",
  "ramda": "/ramda/static-1.7",
  "company-details-service-types": "/company-details-service-types/static-1.3877",
  "billing-payments-client-types": "/billing-payments-client-types/static-1.3935",
  "react-performance-metrics-lib": "/react-performance-metrics-lib/static-1.503",
  "account-and-billing-fintech-outages": "/account-and-billing-fintech-outages/static-3.18485",
  "pricing-pages-api": "/pricing-pages-api/static-1.13447",
  "ContentComponents": "/ContentComponents/static-2.71145",
  "marketing-contacts-lib": "/marketing-contacts-lib/static-1.9747",
  "marketing-email-service-types": "/marketing-email-service-types/static-1.1878",
  "messaging-editing-lib": "/messaging-editing-lib/static-1.46091",
  "messaging-usage-based-billing-components-lib": "/messaging-usage-based-billing-components-lib/static-1.953",
  "automation-ui-source-apps": "/automation-ui-source-apps/static-1.18698",
  "automation-ui-types": "/automation-ui-types/static-1.19616",
  "messaging-types-lib": "/messaging-types-lib/static-1.45828",
  "onboarding-settings-client": "/onboarding-settings-client/static-1.4447",
  "sequences-client-types-lib": "/sequences-client-types-lib/static-1.7795",
  "commerce-tax-lib": "/commerce-tax-lib/static-1.467",
  "property-description-translator": "/property-description-translator/static-1.3793",
  "SalesContentIndexUI": "/SalesContentIndexUI/static-3.9157",
  "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.3572",
  "totals-ui-components": "/totals-ui-components/static-1.23418",
  "advanced-menus-core": "/advanced-menus-core/static-1.15036",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.11990",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.33887",
  "segments-query-core": "/segments-query-core/static-1.1359",
  "demographics-service-types": "/demographics-service-types/static-1.1597",
  "eligibility-engine-service-types": "/eligibility-engine-service-types/static-1.3129",
  "automation-ui-ubb": "/automation-ui-ubb/static-1.5532",
  "blueimp-md5": "/blueimp-md5/static-1.8",
  "content-embed-lib": "/content-embed-lib/static-1.7285",
  "data-token-views": "/data-token-views/static-1.16281",
  "forms-utils-lib": "/forms-utils-lib/static-1.12468",
  "payments-embed-points-lib": "/payments-embed-points-lib/static-1.12910",
  "simple-menus-core": "/simple-menus-core/static-1.15035",
  "simple-menus-lib": "/simple-menus-lib/static-1.16552",
  "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.4200",
  "videoconference-integration-components": "/videoconference-integration-components/static-1.6735",
  "automation-applications-service-types": "/automation-applications-service-types/static-1.3457",
  "automation-platform-service-types": "/automation-platform-service-types/static-1.2562",
  "ContentEditorUI": "/ContentEditorUI/static-2.76948",
  "short-messages-app-service-client": "/short-messages-app-service-client/static-1.3925",
  "web-interactives-components": "/web-interactives-components/static-1.13658",
  "web-interactives-data": "/web-interactives-data/static-1.13659",
  "messaging-shared-utils-lib": "/messaging-shared-utils-lib/static-1.402",
  "messaging-user-info-utils-lib": "/messaging-user-info-utils-lib/static-1.572",
  "email-portal-health-service-types": "/email-portal-health-service-types/static-1.921",
  "FireAlarmUi": "/FireAlarmUi/static-1.4468",
  "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.4122",
  "commerce-totals-service-types": "/commerce-totals-service-types/static-1.3773",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "automation-ui-core": "/automation-ui-core/static-2.21552",
  "automation-ui-usage-tracking": "/automation-ui-usage-tracking/static-1.21015",
  "data-studio-ubb": "/data-studio-ubb/static-1.2544",
  "backbone": "/backbone/static-1.6",
  "campaigns-lib": "/campaigns-lib/static-1.26858",
  "collaboration-sidebar": "/collaboration-sidebar/static-1.57621",
  "content-management-data-lib": "/content-management-data-lib/static-1.5310",
  "copilot-plugins": "/copilot-plugins/static-1.10936",
  "cta-picker": "/cta-picker/static-1.36245",
  "customer-agent-discovery-components-lib": "/customer-agent-discovery-components-lib/static-1.2914",
  "editor-components": "/editor-components/static-1.13150",
  "editor-iframe-lib": "/editor-iframe-lib/static-1.8321",
  "error-messaging-js": "/error-messaging-js/static-1.5137",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.85678",
  "pictos": "/pictos/static-7.183",
  "react-transition-group": "/react-transition-group/static-2.63",
  "redux-request-state": "/redux-request-state/static-1.10592",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.1690",
  "smart-content-core": "/smart-content-core/static-1.42274",
  "smart-content-lib": "/smart-content-lib/static-1.42927",
  "social-composer-lib": "/social-composer-lib/static-1.58836",
  "structured-content-lib": "/structured-content-lib/static-1.25033",
  "theme-previewer-lib": "/theme-previewer-lib/static-1.53091",
  "tinymce-copilot": "/tinymce-copilot/static-1.16270",
  "xray-recommendation-lib": "/xray-recommendation-lib/static-1.7823",
  "automation-ui-routing": "/automation-ui-routing/static-1.20973",
  "sql-reporting-client-types": "/sql-reporting-client-types/static-1.5583",
  "jquery": "/jquery/static-3.6",
  "attribution-lib": "/attribution-lib/static-1.42038",
  "campaigns-utils-lib": "/campaigns-utils-lib/static-1.3109",
  "reporting-enablement": "/reporting-enablement/static-1.22699",
  "chatspot-widget-iframe": "/chatspot-widget-iframe/static-1.21000",
  "collaboration-sidebar-common": "/collaboration-sidebar-common/static-1.2418",
  "forms-ai-lib": "/forms-ai-lib/static-1.4225",
  "codemirror-dlb": "/codemirror-dlb/static-1.58507",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-undo": "/redux-undo/static-1.10",
  "seo-tools-lib": "/seo-tools-lib/static-1.6374",
  "report-customization-components": "/report-customization-components/static-1.12975",
  "data-quality-ui-library": "/data-quality-ui-library/static-1.12732",
  "html-to-image": "/html-to-image/static-1.52",
  "reporting-filters": "/reporting-filters/static-1.163",
  "reporting-insights-lib": "/reporting-insights-lib/static-1.1561"
}
};
